import { render, staticRenderFns } from "./yonghuzu.vue?vue&type=template&id=1f582af6"
import script from "./yonghuzu.vue?vue&type=script&lang=js"
export * from "./yonghuzu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports